import React from 'react';
import { CgSpinner } from 'react-icons/cg';

export const LoadingSpinnerAlt = ({ color, isFixed }) => {
  const fixedPositionClasses = isFixed ? "fixed inset-1/2" : null;
  return (
    <div className={`${fixedPositionClasses} flex flex-col justify-center items-center`}>
      <div className={`h-32 w-32 flex flex-col justify-center items-center  p-3 rounded-xl`}>
        <CgSpinner className={"text-5xl animate-spin mb-3"} />
        <span className={"text-sm opacity-75"}>Loading...</span>
      </div>
    </div>
  )
}
